import React from 'react';
import { Modal } from 'bloomer/lib/components/Modal/Modal';
import { ModalBackground } from 'bloomer/lib/components/Modal/ModalBackground';
import { ModalCard } from 'bloomer/lib/components/Modal/Card/ModalCard';
import { ModalCardHeader } from 'bloomer/lib/components/Modal/Card/ModalCardHeader';
import { ModalCardTitle } from 'bloomer/lib/components/Modal/Card/ModalCardTitle';
import { Delete } from 'bloomer/lib/elements/Delete';
import { ModalCardBody } from 'bloomer/lib/components/Modal/Card/ModalCardBody';
import { ModalCardFooter } from 'bloomer/lib/components/Modal/Card/ModalCardFooter';
import { Button } from 'bloomer/lib/elements/Button';
import Conditional from './Conditional';

const AppModal = ({
  children,
  header,
  cancelBttn,
  confirmBttn,
  isOpen,
  handleClose = () => {},
}: {
  header: JSX.Element | JSX.Element[] | string;
  confirmBttn?: JSX.Element | JSX.Element[] | string | undefined;
  cancelBttn?: JSX.Element | JSX.Element[] | string | undefined;
  children: JSX.Element | JSX.Element[] | string;
  isOpen: boolean;
  handleClose?: () => void;
}) => (
  <Modal isActive={isOpen}>
    <ModalBackground />
    <ModalCard>
      <ModalCardHeader>
        <ModalCardTitle>{header}</ModalCardTitle>
        <Delete onClick={handleClose} />
      </ModalCardHeader>
      <ModalCardBody>{children}</ModalCardBody>
      <ModalCardFooter>
        <Conditional check={confirmBttn !== undefined}>
          <Button isColor="success">{confirmBttn}</Button>
        </Conditional>
        <Conditional check={cancelBttn !== undefined}>
          <Button onClick={handleClose} isColor="warning">
            {cancelBttn}
          </Button>
        </Conditional>
      </ModalCardFooter>
    </ModalCard>
  </Modal>
);

export default AppModal;
